export const locale = {
    lang: 'nl',
    data: {
      'EDITOR': {
        'ACERCADE': 'Optioneel, voordat u de enquête maakt, kunt u enkele kenmerken ervan bewerken, de aangebrachte wijzigingen kunnen in de enquête worden bekeken zodra u deze opent',
        'CONCAMBIOS': 'Er zijn wijzigingen in de enquête-configuratie gedetecteerd, u moet eerst de enquête genereren om de aangebrachte wijzigingen toe te passen, later kunt u de stap voltooien',
        'CARGANDO': 'Informatie laden',
        'GUARDANDO': 'Wijzigingen opslaan',
        'CONFIGADICIONAL': {
          'TITULO': 'Extra configuratie',
          'SUBTITULO': 'Deze instellingen zijn van toepassing op de enquête voor alle talen',
          'DISPONIBLES': 'Beschikbare bedieningselementen',
          'SAVEOK': 'De configuratie is succesvol bijgewerkt',
          'CONTROLES': {
            'PIN': 'Schakel onderzoeksbescherming in met gebruikerspincode',
            'RANDOM': 'Schakel de willekeurige validatievraag in',
            'LIDERES': 'Toon namen van leiders (CEO / Boss) in perspectieven van verklaringen'
          }
        },
        'ELEMENTOS': {
          'GUIA': 'Elementen van dit blok',
          'COLORES': {
            'ORIGINAL': 'Ongewijzigd element',
            'MODIFICADO': 'Gewijzigd element'
          },
          'TOOLTIPS': {
            'ORIGINAL': 'Er is geen element gewijzigd',
            'MODIFICADO': 'Een of meer elementen zijn gewijzigd',
            'COMPLETO': 'Alle elementen zijn gewijzigd'
          },
          'ETIQUETAS': {
            'IMAGEN': {
              'NOHAY': 'Er is geen plaatje',
              'ACTUAL': 'Huidige afbeelding'
            },
            'TEXTO': {
              'INGRESAR': 'Voer uw tekst in'
            }
          },
          'BOTONES': {
            'ENTRAR': 'Bewerk enquêtekenmerken',
            'REGRESAR': 'Ga terug',
            'CONTINUAR': 'Doorgaan met',
            'CANCELAR': 'annuleren',
            'GUARDAR': 'Wijzigingen opslaan',
            'IMAGEN': 'Verander afbeelding',
            'EDITOR': 'Bewerk bericht',
            'ELEMENTOS': 'Helpen',
            'ACTIVAR': 'Laten zien',
            'DESACTIVAR': 'Verbergen',
            'ACEPTAR': 'Accepteren',
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': 'Log in',
            'PASOS': {
              'LOGO': {
                'TITULO': 'Logo van de makelaar',
                'ELEMENTOS': {
                  'logo': 'U kunt een afbeelding uploaden om het logo van de makelaar te wijzigen'
                }
              },
              'INSTRUCCIONES': {
                'TITULO': 'Eerdere instructies',
                'ELEMENTOS': {
                  'text': 'U kunt de instructies schrijven die u wilt weergeven voordat u aan de enquête begint'
                }
              },
              'LOGINFORM': {
                'TITULO': 'Login formulier',
                'ELEMENTOS': {
                  'inputPlaceHolderPass': 'U kunt de hinttekst voor het veld "wachtwoord" wijzigen',
                  'buttons_login_label': 'U kunt de tekst van de login-knop wijzigen',
                  'recoveryAccessKey_text': 'U kunt de knoptekst wijzigen om het wachtwoord te herstellen',
                }
              },
              'BACKGROUND': {
                'TITULO': 'Achtergrond afbeelding',
                'ELEMENTOS': {
                  'backgroudImage': 'U kunt de achtergrondafbeelding wijzigen die op dit scherm wordt weergegeven',
                }
              },
            }
          },
          'GENERICOS': {
            'TITULO': 'Generieke elementen',
            'PASOS': {
              'LOGO': {
                'TITULO': 'Logo van de makelaar',
                'ELEMENTOS': {
                  'logo': 'U kunt een afbeelding uploaden om het logo van de makelaar te wijzigen'
                }
              },
              'HEADER': {
                'TITULO': 'Header-elementen',
                'ELEMENTOS': {
                  'buttons_logout_label': 'U kunt de tekst van de login-knop wijzigen',
                  'header_logo': 'U kunt de afbeelding van het systeemlogo wijzigen',
                  'isShowLastLogin_active': 'U kunt ervoor kiezen om de datum van de laatste toegang weer te geven of te verbergen',
                  'backgroundImage': 'U kunt de achtergrondafbeelding wijzigen die op dit scherm wordt weergegeven',
                  'header_showUserName': 'U kunt ervoor kiezen om de gebruikersnaam weer te geven of te verbergen'
                }
              },
            }
          },
          'BIENVENIDA': {
            'TITULO': 'Welkom scherm',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': 'Scherminhoud',
                'ELEMENTOS': {
                  'text': 'U kunt de inhoud van het welkomstscherm wijzigen',
                  'buttons_next_label': 'U kunt de knoptekst wijzigen om door te gaan',
                }
              },
              'LOGOUT': {
                'TITULO': 'Bericht bij uitloggen',
                'ELEMENTOS': {
                  'title': 'U kunt de titel van het bericht wijzigen',
                  'text': 'U kunt de tekst van het bericht wijzigen',
                  'buttons_cancel_label': 'U kunt de knoptekst wijzigen om de actie te annuleren',
                  'buttons_logout_label': 'U kunt de tekst van de knop wijzigen om uit te loggen',
                }
              },
            }
          },
          'INSTRUCCIONES': {
            'TITULO': 'Instructie scherm',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': 'Scherminhoud',
                'ELEMENTOS': {
                  'text': 'U kunt de inhoud van het instructiescherm wijzigen',
                  'buttons_previous_label': 'U kunt de knoptekst wijzigen om terug te gaan',
                  'buttons_start_label': 'U kunt de knoptekst wijzigen om te starten',
                  'buttons_continue_label': 'U kunt de knoptekst wijzigen om door te gaan',
                }
              },
              'LOGOUT': {
                'TITULO': 'Bericht bij uitloggen',
                'ELEMENTOS': {
                  'title': 'U kunt de titel van het bericht wijzigen',
                  'text': 'U kunt de tekst van het bericht wijzigen',
                  'buttons_cancel_label': 'U kunt de knoptekst wijzigen om de actie te annuleren',
                  'buttons_logout_label': 'U kunt de tekst van de knop wijzigen om uit te loggen',
                }
              },
            }
          },
          'TERMINOS': {
            'TITULO': 'Acceptatiebericht van de enquête',
            'PASOS': {
              'ACTIVAR': {
                'TITULO': 'Activeer het bericht om de enquête te accepteren of te weigeren',
                'ELEMENTOS': {
                  'active': 'Activeer pre-start bericht'
                }
              },
              'CONTENIDO': {
                'TITULO': 'Berichtinhoud',
                'ELEMENTOS': {
                  'header_title': 'U kunt de titel van het bericht wijzigen',
                  'text': 'U kunt de inhoud van het bericht wijzigen',
                  'buttons_previous_label': 'U kunt de knoptekst wijzigen om terug te gaan',
                  'buttons_acept_label': 'U kunt de knoptekst wijzigen om de enquête af te wijzen',
                  'buttons_cancel_label': 'U kunt de knoptekst wijzigen om de enquête te accepteren'
                }
              },
              'LOGOUT': {
                'TITULO': 'Bericht bij uitloggen',
                'ELEMENTOS': {
                  'title': 'U kunt de titel van het bericht wijzigen',
                  'text': 'U kunt de tekst van het bericht wijzigen',
                  'buttons_cancel_label': 'U kunt de knoptekst wijzigen om de actie te annuleren',
                  'buttons_logout_label': 'U kunt de tekst van de knop wijzigen om uit te loggen',
                }
              },
              'NOACEPT': {
                'TITULO': 'Bericht bij afwijzing van de enquête',
                'ELEMENTOS': {
                  'title': 'U kunt de titel van het bericht wijzigen',
                  'text': 'U kunt de tekst van het bericht wijzigen',
                  'buttons_saveAndExit_label': 'U kunt de knoptekst wijzigen om te bevestigen en af te sluiten',
                }
              },
            }
          },
          'SURVEY': {
            'TITULO': 'Onderzoeksscherm',
            'PASOS': {
              'NAV': {
                'TITULO': 'Navigatie knoppen',
                'ELEMENTOS': {
                  'buttons_next_label': 'U kunt de knoptekst wijzigen om door te gaan',
                  'buttons_previous_label': 'U kunt de knoptekst wijzigen om terug te gaan',
                  'buttons_finish_label': 'U kunt de knoptekst wijzigen om de enquête te beëindigen',
                }
              },
              'INSTRUCCIONES': {
                'TITULO': 'Instructie zijpaneel',
                'ELEMENTOS': {
                  'button_label': 'U kunt de knoptekst wijzigen om het instructievenster weer te geven',
                  'active': 'U kunt ervoor kiezen om de knop op het instructiepaneel weer te geven of te verbergen',
                  'text': 'U kunt de inhoud van het instructiescherm wijzigen',
                }
              },
              'SOPORTE': {
                'TITULO': 'Zijpaneel met steunpunten',
                'ELEMENTOS': {
                  'button_label': 'U kunt de knoptekst wijzigen om het paneel met ondersteuningstips weer te geven',
                  'active': 'U kunt ervoor kiezen om de paneelknop voor ondersteuningstips weer te geven of te verbergen',
                  'text': 'U kunt de inhoud van het scherm met ondersteuningstips wijzigen',
                }
              },
              'COLUMNA1': {
                'TITULO': 'Uitspraken: perspectief 1',
                'ELEMENTOS': {
                  'title': 'U kunt de kolomtitel van perspectief 1 wijzigen',
                  'tooltip_active': 'U kunt ervoor kiezen om de knopinfo voor de kolomtitel weer te geven of te verbergen',
                  'tooltip_text': 'U kunt de inhoud van de knopinfo voor de kolomtitel wijzigen',
                }
              },
              'COLUMNA2': {
                'TITULO': 'Uitspraken: perspectief 2',
                'ELEMENTOS': {
                  'title': 'U kunt de kolomtitel van perspectief 2 wijzigen',
                  'tooltip_active': 'U kunt ervoor kiezen om de knopinfo voor de kolomtitel weer te geven of te verbergen',
                  'tooltip_text': 'U kunt de inhoud van de knopinfo voor de kolomtitel wijzigen',
                }
              },
              'FINISH_1': {
                'TITULO': 'Bericht aan het einde van de enquête',
                'ELEMENTOS': {
                  'title': 'U kunt de titel van het bericht wijzigen',
                  'textAnswered': 'U kunt de tekst van het bericht dat wordt weergegeven bij het beantwoorden van alle vragen wijzigen',
                  'textNotAnswered': 'U kunt de tekst van het weergegeven bericht wijzigen door niet alle vragen te beantwoorden',
                  'textFooter': 'U kunt de tekst van het bericht wijzigen',
                  'buttons_previous_label': 'U kunt de knoptekst wijzigen om terug te gaan',
                  'buttons_close_label': 'U kunt de knoptekst wijzigen om de enquête te beëindigen',
                }
              },
              'FINISH_2': {
                'TITULO': 'Bericht na het invullen van de enquête',
                'ELEMENTOS': {
                  'windowFinishMessage_title': 'U kunt de titel van het bericht wijzigen',
                  'windowFinishMessage_text': 'U kunt de tekst van het bericht wijzigen',
                  'windowRanking_active': 'U kunt ervoor kiezen om het bericht weer te geven of te verbergen om de enquête te beoordelen',
                  'windowRanking_text': 'U kunt de tekst van het bericht wijzigen om de enquête te beoordelen',
                  'windowFinishMessage_buttons_close_label': 'U kunt de knoptekst wijzigen om door te gaan',
                }
              },
              'LOGOUT_1': {
                'TITULO': 'Bericht bij uitloggen',
                'ELEMENTOS': {
                  'title': 'U kunt de titel van het bericht wijzigen',
                  'text': 'U kunt de tekst van het bericht wijzigen',
                  'textBandRequired': 'U kunt de tekst van het onomkeerbare waarschuwingsbericht wijzigen',
                  'buttons_previous_label': 'U kunt de knoptekst wijzigen om de actie te annuleren',
                  'buttons_saveAndExit_label': 'U kunt de knoptekst wijzigen om wijzigingen op te slaan en uit te loggen',
                }
              },
              'LOGOUT_2': {
                'TITULO': 'Bericht na uitloggen',
                'ELEMENTOS': {
                  'title': 'U kunt de titel van het bericht wijzigen',
                  'text': 'U kunt de tekst van het bericht wijzigen',
                  'buttons_close_label': 'U kunt de knoptekst wijzigen om door te gaan',
                }
              },
            }
          },
        }
      }
    }
};
